import { IDefaultTableColumnConfig, ILeadsFacebookConfig, IDualAxisLineGraphConfig } from '../../../../_shared/models/models-index';

export class LeadsFacebookConfig implements ILeadsFacebookConfig {

    public graphConfig: IDualAxisLineGraphConfig = null;
    public summaryTableColumns: IDefaultTableColumnConfig[] = [];
}
